export default __webpack_public_path__ + "img-reading-in-bed.webp";